import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { castList } from "@/mocks/film";

const VIEWS = [
  { id: "table", label: "表格视图", icon: "ri-table-line" },
  { id: "grid", label: "卡片视图", icon: "ri-layout-grid-line" },
];

export default function CastSection() {
  const [view, setView] = useState<"table" | "grid">("table");

  return (
    <section id="cast" className="scroll-mt-32 bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <Reveal>
            <SectionHeading
              index="04 / 演员表"
              title="演员与角色对照表"
              desc="演员表按主要角色顺序排列，并附上各自的表演看点备注。可在表格与卡片两种视图之间切换，方便快速核对或逐条阅读。"
            />
          </Reveal>
          <Reveal delay={60}>
            <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-200">
              {VIEWS.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setView(item.id as "table" | "grid")}
                  className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                    view === item.id
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-foreground-950"
                  }`}
                  aria-pressed={view === item.id}
                >
                  <i className={item.icon} aria-hidden="true" />
                  {item.label}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        {view === "table" ? (
          <Reveal className="mt-8 md:mt-10">
            <div className="rounded-lg border border-background-200 overflow-hidden bg-background-50">
              <div className="overflow-x-auto">
                <table className="w-full min-w-[560px] border-collapse text-left">
                  <thead>
                    <tr className="bg-secondary-100 text-secondary-900">
                      <th scope="col" className="px-5 py-3.5 text-sm font-label font-medium">
                        演员
                      </th>
                      <th scope="col" className="px-5 py-3.5 text-sm font-label font-medium">
                        饰演角色
                      </th>
                      <th scope="col" className="px-5 py-3.5 text-sm font-label font-medium">
                        表演备注
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {castList.map((row, index) => (
                      <tr
                        key={row.character}
                        className={index % 2 === 1 ? "bg-background-100/60" : "bg-background-50"}
                      >
                        <td className="px-5 py-4 text-sm font-medium text-foreground-950 whitespace-nowrap">
                          {row.actor}
                        </td>
                        <td className="px-5 py-4 text-sm text-primary-700 whitespace-nowrap">
                          {row.character}
                        </td>
                        <td className="px-5 py-4 text-sm text-foreground-600">{row.note}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Reveal>
        ) : (
          <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {castList.map((row, index) => (
              <Reveal key={row.character} delay={(index % 3) * 60}>
                <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 flex gap-4">
                  <span className="w-11 h-11 shrink-0 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-lg">
                    <i className="ri-user-star-line" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {row.actor}
                    </h3>
                    <p className="mt-0.5 text-xs text-primary-700 font-label">饰 {row.character}</p>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{row.note}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}